import React from "react";
import { GraphsContainer, GraphsGrid,ErrorCenter } from "./styles";
import LiveSentiment from "./LiveSentiment";
import DurationSelector from "./DurationSelector";
import SocialMentions from "./SocialMentions";
import Error from "../../../../common/Error";
function Graphs({ selectedStock }) {
  const [duration, setDuration] = React.useState("1D");
  if(!selectedStock){
    return <GraphsContainer>
      <ErrorCenter>
      <Error text="No Stock Selected"/></ErrorCenter>
    </GraphsContainer>
  }
  return (
    <GraphsContainer>
      <DurationSelector duration={duration} setDuration={setDuration} />
      <GraphsGrid>
        <LiveSentiment duration={duration} selectedStock={selectedStock} />
        <SocialMentions duration={duration} selectedStock={selectedStock} />
      </GraphsGrid>
    </GraphsContainer>
  );
}
export default Graphs;
